<template>
  <div class="packets-period">
    <div :class="{ active: monthActiveReal == 0 }" @click="changeMonth(0)">3 m-c</div>
    <div :class="{ active: monthActiveReal == 1 }" @click="changeMonth(1)">6 m-c</div>
    <div :class="{ active: monthActiveReal == 2 }" @click="changeMonth(2)">12 m-c</div>
  </div>
</template>

<script>
export default {
  name: 'PacketsPeriod',
  data(){
    return{
      monthActiveReal: 1,
    }
  },
  computed:{
    monthActive(){
      return this.$store.state.monthActive;
    },
  },
  created(){
    this.getMonth();
    this.setMonth();
  },
  watch: {
    monthActive(){
      this.getMonth();
    }
  },
  methods: {
    changeMonth(id){
      this.$store.commit('changeMonth', id);
      if(typeof localStorage.period == 'undefined'){
        localStorage.setItem('period', id);
      }else{
        localStorage.period = id;
      }
      let formData;
      if(localStorage.formData !== undefined) {
        formData = JSON.parse(localStorage.formData);
      } else {
        formData = {};
      }
      if(formData.packet === undefined) {
        formData.packet = {};
      }
      if(id == 0) {
        formData.packet.period = 3;
      } else if(id == 1) {
        formData.packet.period = 6;
      } else if(id == 2) {
        formData.packet.period = 12;
      }
      localStorage.setItem('formData', JSON.stringify(formData));
    },
    getMonth(){
      if(typeof localStorage.period == 'undefined'){
        this.monthActiveReal = this.monthActive;
      }else{
        this.monthActiveReal = localStorage.period;
      }
    },
    setMonth() {
      let formData;
      if(localStorage.formData !== undefined) {
        formData = JSON.parse(localStorage.formData);
      } else {
        formData = {};
      }
      if(formData.packet === undefined) {
        formData.packet = {};
      }
      if(this.monthActiveReal == 0) {
        formData.packet.period = 3;
      } else if(this.monthActiveReal == 1) {
        formData.packet.period = 6;
      } else if(this.monthActiveReal == 2) {
        formData.packet.period = 12;
      }
      localStorage.setItem('formData', JSON.stringify(formData));
    },
  }
}
</script>
<style scoped lang="scss">
  div.packets-period { width: 350px; display: flex; justify-content: space-between; }
  div.packets-period div { width: 100px; height: 40px; text-align: center; line-height: 40px; color: #fff; font-weight: 300; font-size: 15px;
    cursor: pointer; background: $grayLight; border-radius: 3px; }
  div.packets-period div:hover { background: $orangeDark; }
  div.packets-period div.active { background: $orangeDark; }

  div.packets-period div { background: #fff; border: 1px solid $grayLight; color: $fontBlack; }
  div.packets-period div:hover { color: #fff; border: 1px solid $orangeDark; }
  div.packets-period div.active { color: #fff; border: 1px solid $orangeDark; }

  @media (max-width: 450px) {
    div.packets-period { width: calc(100vw - 20px); }
    div.packets-period div { margin: 0 10px; }
  }
</style>
